<div class="button__wrapper" role="button" tabindex="0" [ngClass]="{'tall': extraHeight}">
    {{label | translate}}
</div>
